module.exports = __webpack_public_path__ + "media/images/icons/SVG/023-a056228d3d94a8385f6b9d063167b05e.svg";